import purpleLogo from '@/assetsDomesticLight/images/logo.svg';
import blueLogo from '@/assetsOverseas/images/logo.svg';
import purpleMinLogo from '@/assetsDomesticLight/images/minLogo.svg';
import blueMinLogo from '@/assetsOverseas/images/minLogo.svg';
import baiyuLogo from '@/assetsDomesticLight/images/baiyu.svg';

import purpleLoginBg from '@/assetsDomesticLight/images/login/login.jpg';
import blueLoginBg from '@/assetsOverseas/images/login/login.jpg';

import purpleLoginLogo from '@/assetsDomesticLight/images/login/login-logo.png';

import blueLayoutAdd from '@/assetsDomesticLight/images/layout/add.png';
import purpleLayoutAdd from '@/assetsOverseas/images/layout/add.png';

import purpleFavicon from '@/assetsDomesticLight/favicon.svg';
import blueFavicon from '@/assetsOverseas/favicon.svg';

import purpleNoData from '@/assetsDomesticLight/images/noData.png';
import blueNoData from '@/assetsOverseas/images/noData.png';

import purpleFlowIndent from '@/assetsDomesticLight/images/flow/indent.png';
import blueFlowIndent from '@/assetsOverseas/images/flow/indent.png';

import purpleImgHeadHome from '@/assetsDomesticLight/images/home/img-head-home.png';
import blueImgHeadHome from '@/assetsOverseas/images/home/img-head-home.png';

import purpleWebCall from '@/assetsDomesticLight/images/webCall/webcall-bg.png';
import blueWebCall from '@/assetsOverseas/images/webCall/webcall-bg.png';

import purpleNoDataV2 from '@/assetsDomesticLight/images/noData-v2.png';
import blueNoDataV2 from '@/assetsOverseas/images/noData-v2.png';
import blueAiGeneratingV2 from '@/assetsDomesticLight/images/aiGening.gif';
import purpleAiGeneratingV2 from '@/assetsOverseas/images/aiGening.gif';
import purpleNoPermission from '@/assetsDomesticLight/images/no-permission.png';
import blueNoPermission from '@/assetsOverseas/images/no-permission.png';

import spaceIconPurple from '@/assetsDomesticLight/images/layout/space.svg';
import spaceIconBlue from '@/assetsOverseas/images/layout/space.svg';

/** Detect if the app is embedded from Baiyu platform. */
function isBaiyuMode() {
  try {
    try {
      if (sessionStorage.getItem('sbt_baiyu_hardware_embed') === '1') return true;
    } catch {
      // Private mode / blocked storage
    }
    const urls = [window.location.href];
    if (document.referrer) urls.push(document.referrer);
    try {
      if (window.self !== window.top && window.top?.location?.href) {
        urls.push(window.top.location.href);
      }
    } catch {
      // Cross-origin iframe
    }
    if (new URLSearchParams(window.location.search).has('baiyu')) return true;
    return urls.some(url => String(url).toLowerCase().includes('baiyu'));
  } catch {
    return false;
  }
}

const logoMap = {
  blue: blueLogo,
  purple: purpleLogo
};
const theme = IS_DOMESTIC ? 'purple' : 'blue';
const useBaiyuLogo = isBaiyuMode();

const loginBgMap = {
  blue: blueLoginBg,
  purple: purpleLoginBg
};
const minLogoMap = {
  blue: blueMinLogo,
  purple: purpleMinLogo
};
// Overseas login logo uses the same logo as the layout header for consistency
const loginLogoMap = {
  blue: blueLogo,
  purple: purpleLoginLogo
};
const aiGeneratingMap = {
  blue: purpleAiGeneratingV2,
  purple: blueAiGeneratingV2
};

const layoutAddMap = {
  blue: blueLayoutAdd,
  purple: purpleLayoutAdd
};
const flowIndentMap = {
  blue: blueFlowIndent,
  purple: purpleFlowIndent
};
const faviconMap = {
  blue: blueFavicon,
  purple: purpleFavicon
};

const noDataMap = {
  blue: blueNoData,
  purple: purpleNoData
};

const noDataMapV2 = {
  blue: blueNoDataV2,
  purple: purpleNoDataV2
};

const imgHeadHomeMap = {
  blue: blueImgHeadHome,
  purple: purpleImgHeadHome
};

const webCallMap = {
  blue: blueWebCall,
  purple: purpleWebCall
};

const noPermissionMap = {
  blue: blueNoPermission,
  purple: purpleNoPermission
};

const spaceIconMap = {
  blue: spaceIconBlue,
  purple: spaceIconPurple
};

export const logoSrc = useBaiyuLogo ? baiyuLogo : logoMap[theme];
export const baiyuLogoSrc = baiyuLogo;
export const loginBgSrc = loginBgMap[theme];
export const minLogoSrc = useBaiyuLogo ? baiyuLogo : minLogoMap[theme];
export const loginLogoSrc = useBaiyuLogo ? baiyuLogo : loginLogoMap[theme];
export const layoutAddSrc = layoutAddMap[theme];

export const faviconSrc = faviconMap[theme];
export const noDataSrc = noDataMap[theme];
export const aiGeneratingSrc = aiGeneratingMap[theme];
export const imgHeadHomeSrc = imgHeadHomeMap[theme];
export const webCallSrc = webCallMap[theme];
export const flowIndentSrc = flowIndentMap[theme];
export const noDataSrcV2 = noDataMapV2[theme];
export const noPermissionSrc = noPermissionMap[theme];
export const spaceIconSrc = spaceIconMap[theme];
